<template>
	<div>
		<ext-dialog
			v-model="value"
			:title="$t('basket')"
			:primaryButtonText="$t('checkout')"
			:secondaryButtonText="$t('clear_basket')"
			@primaryButtonAction="onRequestOptions"
			@secondaryButtonAction="CLEAR"
			@closed="close"
		>
			<template #body>
				<div v-if="items.length === 0" class="text-center pa-6">
					{{ $t("basket_empty") }}
				</div>
				<v-list v-else class="pa-2">
					<v-list-item v-for="item in items" :key="item._id" class="pa-4 mb-3 elevation-1">
						<v-list-item-content>
							<v-list-item-title class="subtitle-1 font-medium">
								{{
									item.measurement_no ? `${$t("batch")} #${item.measurement_no}` : `${item.quantity} ${$t("pieces")}`
								}}
							</v-list-item-title>
							<v-list-item-subtitle class="caption grey--text">
								{{ formatMeasurements(item.measurements) }}
							</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-action class="d-flex align-center">
							<v-btn icon small @click.stop="DECREMENT_ITEM(item._id)">
								<v-icon color="primary">icon-minus</v-icon>
							</v-btn>
							<span class="mx-2">{{ item.quantity }}</span>
							<v-btn icon small @click.stop="INCREMENT_ITEM(item._id)">
								<v-icon color="primary">icon-plus</v-icon>
							</v-btn>
							<v-spacer />
							<v-btn icon small @click.stop="REMOVE_ITEM(item._id)">
								<v-icon color="error">icon-delete</v-icon>
							</v-btn>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</template>
		</ext-dialog>

		<proforma-options-dialog v-model="showOptions" @confirm="onOptionsConfirmed" />
	</div>
</template>

<script>
import ExtDialog from "./ExtDialog.vue";
import ProformaOptionsDialog from "./ProformaOptionsDialog.vue";
import remote from "../../../data/remote";
import { mapGetters, mapMutations } from "vuex";

export default {
	name: "BasketDialog",
	components: { ExtDialog, ProformaOptionsDialog },
	props: { value: Boolean },
	data() {
		return {
			showOptions: false,
			pendingPayload: null,
		};
	},
	computed: {
		...mapGetters("basket", ["items"]),
		...mapGetters("auth", ["isAuthenticated"]),
		company() {
			return this.$store.getters.company;
		},
	},
	methods: {
		...mapMutations("basket", ["REMOVE_ITEM", "CLEAR", "INCREMENT_ITEM", "DECREMENT_ITEM"]),
		close() {
			this.$emit("input", false);
		},
		formatMeasurements(measurements = []) {
			return measurements
				.map((m) => {
					const parts = [];
					if (m.length != null) parts.push(m.length);
					if (m.width != null) parts.push(m.width);
					if (m.height != null) parts.push(m.height);
					if (m.pieces != null) parts.push(m.pieces);
					return parts.join("×");
				})
				.join(" ");
		},
		onRequestOptions() {
			if (!this.isAuthenticated) {
				this.$router.push({
					name: "signUp",
					query: { redirect: this.$route.fullPath, openBasket: "1" },
				});
				return;
			}
			if (!this.company || !this.company.id) {
				alert(this.$t("please_create_company"));
				this.$router.push({ name: "companyProfile" });
				return;
			}
			const seller = this.items[0].seller;
			const sender = {
				referenceId: seller.referenceId,
				name: seller.name,
				countryId: seller.countryId,
				isAbstract: seller.isAbstract || false,
			};
			const receiver = {
				referenceId: this.company.id,
				name: this.company.name,
				countryId: this.company.countryId,
				isAbstract: false,
			};
			const products = this.items.map((i) => ({
				productId: i.productId,
				name: i.name,
				unitCode: i.unitCode,
				quantity: i.quantity,
				amount: i.amount || 0,
			}));
			this.pendingPayload = {
				sender,
				receiver,
				date: new Date().toISOString().slice(0, 10),
				shipmentMethod: "land", // default to land
				loadingCountryId: sender.countryId,
				unloadingCountryId: receiver.countryId,
				loadingPoint: "",
				unloadingPoint: "",
				products,
				currency: {
					code: this.company.settings.localization.defaultCurrencyCode,
				},
			};
			this.showOptions = true;
		},
		onOptionsConfirmed(opts) {
			const payload = {
				...this.pendingPayload,
				no: opts.no,
				shippingTerm: {
					code: opts.shippingTerm.code,
					name: opts.shippingTerm.name,
				},
			};
			remote.proformaInvoices.createWithoutValidation(payload, {
				onSuccess: () => {
					this.CLEAR();
					this.close();
					this.$toast?.success(this.$t("proforma_created")) || alert(this.$t("proforma_created"));
				},
				onFail: (err) => {
					this.$toast?.error(err.message || this.$t("error")) || alert(err.message || this.$t("error"));
				},
			});
		},
	},
	mounted() {
		if (this.$route.query.openBasket === "1") {
			this.$emit("input", true);
		}
	},
};
</script>

<style scoped>
.v-list-item {
	border-radius: 8px;
	padding-top: 12px !important;
	padding-bottom: 12px !important;
}
</style>
